import Timer from 'ms-components/icons/Timer';
import { BodyS } from 'ms-pages/Lantern/primitives/Typography';
import { colors } from 'ms-styles/colors';
import { formatQuestionDuration } from 'ms-utils/time';

import { sharedStyles } from './sharedStyles';

type Props = {
  duration: number; // Duration in seconds
};

export const ProblemDurationLabel = ({ duration }: Props) => {
  const formattedDuration = formatQuestionDuration(duration, true);

  return (
    <div
      className={sharedStyles.labelWrapper}
      style={{ backgroundColor: colors.silverHaze }}
    >
      <Timer color={colors.neutralGray} size={18} />
      <BodyS color="neutralGray">{formattedDuration}</BodyS>
    </div>
  );
};
